{
  "welcome": "مرحبًا بك في",
  "instructions": "انقر أدناه لبدء عملية تسجيل الوصول.",
  "startCheckIn": "بدء تسجيل الوصول",
  "missingWarehouseTitle": "المستودع مفقود",
  "missingWarehouseMessage": "الرابط غير صالح، يجب أن يحتوي على معرّف المستودع",
  "recaptchaAttribution": "هذا الموقع محمي بواسطة reCAPTCHA وتسري عليه {privacyPolicy} و{termsOfService} من Google.",
  "recaptchaPrivacyPolicy": "سياسة الخصوصية",
  "recaptchaTermsOfService": "شروط الخدمة",
  "lookupTitle": "أضف الرقم المرجعي أو رقم التأكيد للعثور على موعدك",
  "referenceNumberLabel": "الرقم المرجعي أو رقم التأكيد",
  "referenceNotFoundError": "الرقم المرجعي أو رقم التأكيد لا يطابق أي موعد صالح.",
  "checkIn": "تسجيل الوصول",
  "loadTypeLabel": "نوع الحمولة",
  "directionLabel": "الاتجاه",
  "operationLabel": "العملية",
  "dockLabel": "الرصيف",
  "orDivider": "أو",
  "noReferenceTitle": "ليس لدي رقم تأكيد",
  "noReferenceDescription": "المتابعة بدون موعد باستخدام عملية تسجيل الوصول القياسية.",
  "checkInWithoutAppointment": "تسجيل الوصول بدون موعد",
  "readyToCheckInTitle": "هل أنت مستعد لتسجيل الوصول؟",
  "readyToCheckInDescription": "اضغط أدناه للبدء. ستُدخل بياناتك في الشاشة التالية.",
  "referenceRequiredHint": "يلزم إدخال رقم مرجعي لتسجيل الوصول في هذا الموقع.",
  "haveAppointment": "لدي موعد",
  "direction": {
    "inbound": "وارد",
    "outbound": "صادر",
    "inOut": "وارد وصادر",
    "load": "تحميل",
    "unload": "تفريغ"
  },
  "operation": {
    "live": "مباشر",
    "drop": "إنزال",
    "other": "أخرى"
  }
}
